import {Box} from "@mui/material";
import {CreatePopup} from "components/Admin/Pages/CreatePopup/CreatePopup";
import {Permissions} from "dto/user-dto";
import {BooleanInput, CheckboxGroupInput, NumberInput, PasswordInput, TextInput, useTranslate,} from "react-admin";
import {userService} from "services/userService";

export const UserCreate: React.FC = () => {
  const t = useTranslate();

  const permissions = Object.keys(Permissions).map((permission) => ({
    id: permission,
    name: t(`resources.users.options.permissions.${permission}`),
  }));

  return (
    <CreatePopup createQuery={userService.create}>
      <TextInput source="username" fullWidth size="medium"/>
      <TextInput source="email" fullWidth size="medium"/>
      <PasswordInput source="password" fullWidth size="medium"/>
      <Box sx={{display: "flex", flexDirection: "row", gap: "10px"}}>
        <BooleanInput source="active" defaultValue={true}/>
        <BooleanInput source="emailIsConfirmed" defaultValue={true}/>
      </Box>
      <Box sx={{display: "flex", flexDirection: "row", gap: "10px"}}>
        <NumberInput source="goldCapss" size="medium" min={0} defaultValue={0} fullWidth/>
        <NumberInput source="sparks" size="medium" min={0} defaultValue={0} fullWidth/>
        <NumberInput source="gums" size="medium" min={0} defaultValue={0} fullWidth/>
      </Box>
      <CheckboxGroupInput
        source="permissions"
        choices={permissions}
        defaultValue={[Permissions.PLAY]}
        translateChoice={true}
      />
    </CreatePopup>
  );
};
